/* global isApplePayEnabledForUser:writable */

async function checkApplePayEnabled(applePayRequireCreditCard, applePayMerchantId) {
    if (!window.ApplePaySession) {
        return undefined;
    }

    let isSupported;
    let isDefault;

    if (applePayRequireCreditCard) {
        isSupported = await window.ApplePaySession.canMakePaymentsWithActiveCard(applePayMerchantId);
        isDefault = isSupported;
    } else {
        isSupported = window.ApplePaySession.canMakePayments();
        isDefault = false;
    }

    return { isSupported, isDefault };
}

async function updateApplePayEnabledForUser(applePayRequireCreditCard, applePayMerchantId) {
    if (isApplePayEnabledForUser === undefined) {
        isApplePayEnabledForUser = await checkApplePayEnabled(applePayRequireCreditCard, applePayMerchantId);
    }
}

export async function shouldShowApplePayForUser(applePayRequireCreditCard, applePayMerchantId) {
    await updateApplePayEnabledForUser(applePayRequireCreditCard, applePayMerchantId);
    return isApplePayEnabledForUser;
}
